import corp from "../images/corpbrandsol.png";
import pizza1 from "../images/pizza1.png";
import pizza2 from "../images/pizza2.png";
import pizza3 from "../images/pizza3.png";
import pizza4 from "../images/pizza4.png";
import corp2 from "../images/corp2.png";
import corp3 from "../images/corp3.png";
import ex1 from "../images/ex1.png";
import ex2 from "../images/ex2.png";
import ex3 from "../images/ex3.png";
import ex4 from "../images/ex4.png";
import wood from "../images/wood.png";
import wood2 from "../images/wood2.png";
import wood3 from "../images/wood3.png";
import socio from "../images/socio.png";
import socio2 from "../images/socio2.png";
import socio3 from "../images/socio3.png";

const projects = [
  {
    title: "Corpbrand Solutions LLP",
    description:
      "Created the company’s website from scratch using React and Javascript. An informative site providing knowledge about Corpbrand’s services, their contact information along with client details.",
    images: [corp, corp2, corp3],
    technologies: ["React", "JavaScript", "HTML", "CSS"],
    link: "https://corpbrandsol.com/",
  },
  {
    title: "The <p>izza<a> Code",
    description:
      "A pizza booking app similar to an e-commerce site, offers various types of pizza, login, cart and checkout services. Built using Redux, fetched data using React-router. Styled using Tailwind CSS. Implemented Redux Thunks for middleware services in order to fetch address using createAsyncThunk.",
    images: [pizza1, pizza2, pizza3, pizza4],
    technologies: ["React", "Redux", "JavaScript", "Tailwind CSS"],
    link: "https://github.com/rayyush/the-pizza-code",
  },
  {
    title: "ExploreR",
    description:
      "A checklist site used for keeping track of the cities one visited. Programmatic navigation using useNavigate, dynamic routes with URL parameters, performance optimisation using useMemo and useCallback, optimising bundle size using code splitting.",
    images: [ex1, ex2, ex3, ex4],
    technologies: ["React", "Redux", "JavaScript", "Tailwind CSS"],
    link: "https://github.com/rayyush/ExploreR",
  },
  {
    title: "Woodland Serene",
    description:
      "A hotel booking website, made using React. Client-side filtering as well as API-side filtering and Sorting applied to cabins and bookings. Authentication and data storage is achieved using Supabase. Recharts library helped in building the different charts required along with multiple React hooks to build fast, effcient and reusable components.",
    images: [wood, wood2, wood3],
    technologies: ["React", "Redux", "JavaScript", "Supabase"],
    link: "https://github.com/rayyush/woodland-serene",
  },
  {
    title: "Sociopedia",
    description:
      "A social media app made using MERN stack, including authorisation, authentication, routing, dual colour theme including light mode and dark mode. Backend services using expressjs and mongodb. User can post their photos or share, like, comment on other’s posts. ",
    images: [socio, socio2, socio3],
    technologies: ["React", "Redux", "Expressjs", "Mongodb", "Nodejs"],
    link: "https://github.com/rayyush/sociopedia",
  },
];

export default projects;
